// extracted by mini-css-extract-plugin
export var content = "ParagraphQuote-module--content--a6422";
export var paragraphquote = "ParagraphQuote-module--paragraphquote--d5a5c";
export var paragraphquotehighlighted = "ParagraphQuote-module--paragraphquotehighlighted--1b92a ParagraphQuote-module--paragraphquote--d5a5c";
export var quote = "ParagraphQuote-module--quote--a377d";
export var quotee = "ParagraphQuote-module--quotee--50cd7";
export var quoteerole = "ParagraphQuote-module--quoteerole--0961d";
export var quotemarks = "ParagraphQuote-module--quotemarks--91ee3";
export var quotetext = "ParagraphQuote-module--quotetext--45777";